import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import {
  mutationOptions,
  withError,
  withInvalidate,
} from '@/react-tools/react-query';

import { AdditionalFunctionality } from '../types';
import { buildUrl } from '../settings.service';

import { queryKeys } from './queryKeys';

export function useUpdateAdditionalFunctionalitySettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    updateAdditionalFunctionalitySettings,
    mutationOptions(
      withInvalidate(queryClient, [queryKeys.base()]),
      withError('Unable to update additional functionality settings')
    )
  );
}

async function updateAdditionalFunctionalitySettings(
  settings: Partial<AdditionalFunctionality>
) {
  try {
    await axios.put(buildUrl('additional_functionality'), settings);
  } catch (e) {
    throw parseAxiosError(
      e as Error,
      'Unable to update additional functionality settings'
    );
  }
}
